/** Multi-Pipeline: Kategorien für Filter & Lead-Feld `pipelineId`. */
export const CRM_PIPELINES = [
  { id: 'new_business', label: 'Neukunden' },
  { id: 'renewals', label: 'Bestandskunden / Verlängerung' },
  { id: 'partners', label: 'Partner / Kooperation' },
];

export function pipelineLabel(id) {
  return CRM_PIPELINES.find(p => p.id === id)?.label || id || 'Neukunden';
}
